<template>
  <v-container>
    <v-divider></v-divider>
    <v-row>
      <v-col>
        <p class="text-center"> MAOC &copy; 2026 </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'RequestFooter'
}
</script>
